import { RESOLUTIONS } from 'helpers/globals'

export default function resolutionLookup({ horizontalResolution, verticalResolution, model }) {
  const resolution = RESOLUTIONS.find(r => r.value === `${horizontalResolution} x ${verticalResolution}`)
  if (resolution) { return resolution.text }
  return model && (model.resolution_name.match('12MP 270°') ? '12 MP' : model.resolution)
}



// WEBPACK FOOTER //
// ./src/helpers/cameras/resolutionLookup.js